var React = require('react');

function Burger (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#0072ce;}")),React.createElement("g",{"id":"Layer_2","key":1},React.createElement("g",{"id":"Layer_1-2"},[React.createElement("rect",{"className":"cls-1","width":"28","height":"2","key":0}),React.createElement("rect",{"className":"cls-1","y":"8","width":"28","height":"2","key":1}),React.createElement("rect",{"className":"cls-1","y":"16","width":"28","height":"2","key":2})]))]);
}

Burger.defaultProps = {"viewBox":"0 0 28 18"};

module.exports = Burger;

Burger.default = Burger;
